import React from 'react';
import PropTypes from 'prop-types';

import { Table, Alert } from 'react-bootstrap';

import ItemList from '../ItemList';
import Trash from '../Trash';
import TableHeaderRow from '../TableHeaderRow';
import TableContent from '../TableContent';
import TablePagination from '../TablePagination';
import TablePageHeader from '../TablePageHeader';

const TableList = ({ childProps, isFreeUserAtLimit, isPaginationOn, isFree }) => {
  return (
    <>
      <Trash {...childProps.trashProps} />
      <TablePageHeader {...childProps.tablePageHeaderProps} />
      <ItemList {...childProps.itemListProps}>
        <Table responsive hover size="sm">
          <TableHeaderRow isFree={isFree} {...childProps.tableHeaderRowProps} />
          <TableContent {...childProps.tableContentProps} />
        </Table>
        {isFreeUserAtLimit && (
          <Alert variant="info">Upgrade Plan to Add More Items (Check Recycle Bin)</Alert>
        )}
      </ItemList>
      <TablePagination {...childProps.tablePaginationProps} isPaginationOn={isPaginationOn} />
    </>
  );
};

TableList.defaultProps = {
  isPaginationOn: false,
  isFree: false
};

TableList.propTypes = {
  childProps: PropTypes.object.isRequired,
  isFreeUserAtLimit: PropTypes.bool.isRequired,
  isPaginationOn: PropTypes.bool,
  isFree: PropTypes.bool
};

export default TableList;
